import { Modal } from "@circleco/compass/components/Modal";

import { DetailsModalLoader } from "@/react/components/ImagePostCompass/DetailsModal/DetailsModalLoader";
import { getCreatePostModalSize } from "@/react/components/Spaces/ImageSpace/ImagePostModalCompass/getCreatePostModalSize";
import {
  useExtraLargeScreenMediaQuery,
  useTailwindLgScreenMediaQuery,
} from "@/react/hooks/useMediaQuery";
import { useClosePostModal } from "@/react/hooks/usePostModalNavigation";

/** Mirrors `DetailsModalComponent`'s loading state while the PostModal chunk loads. */
export const ImagePostModalSkeleton = () => {
  const isXlScreen = useExtraLargeScreenMediaQuery();
  const isLgScreen = useTailwindLgScreenMediaQuery();
  const closePostModal = useClosePostModal();

  return (
    <Modal.Root
      open
      size={getCreatePostModalSize({ isLgScreen, isXlScreen })}
      onOpenChange={open => {
        if (!open) closePostModal();
      }}
    >
      <Modal.Content>
        <Modal.Body customLayout={isLgScreen}>
          <DetailsModalLoader
            isLgScreen={isLgScreen}
            onClose={closePostModal}
          />
        </Modal.Body>
      </Modal.Content>
    </Modal.Root>
  );
};
